import {Injectable} from '@angular/core';
import {Config} from './config.service';
import {PushService} from './push.service';
import {ToastDirective} from '../directives/toast/toast';
import {LocalStorageService} from './localStorage.service';

@Injectable()
export class ToolsService {
  constructor(
    public readonly config: Config,
    public readonly toast: ToastDirective,
    public readonly localStorageService: LocalStorageService,
    public readonly pushService: PushService,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/tools.service.ts